import routes from './fakeprofile.routes';

export const fakeprofileModule = {
    routes
};